module.exports = __webpack_public_path__ + "media/images/icons/whatsapp-icon-75a16dc78cb3e5bb615d91ccf9642dfa.svg";